import React from 'react';
import PlayerAvatar from './PlayerAvatar';

// Иконки бокового меню — тот же line-стиль (stroke=currentColor,
// strokeWidth=2, круглые окончания), что и у нижней навигации (Navigation.js),
// вместо эмодзи, которые на разных платформах/шрифтах выглядели по-разному
// и не всегда попадали в стиль приложения.
const icons = {
  players: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21V19C16 16.7909 14.2091 15 12 15H5C2.79086 15 1 16.7909 1 19V21" />
      <circle cx="8.5" cy="7" r="4" />
      <path d="M23 21V19C22.9993 17.1771 21.765 15.5857 20 15.13" />
      <path d="M16 3.13C17.7699 3.58317 19.0078 5.17799 19.0078 7.005C19.0078 8.83201 17.7699 10.4268 16 10.88" />
    </svg>
  ),
  bank: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="9" cy="7" rx="6" ry="3" />
      <path d="M3 7V17C3 18.66 5.69 20 9 20C12.31 20 15 18.66 15 17V7" />
      <path d="M3 12C3 13.66 5.69 15 9 15C12.31 15 15 13.66 15 12" />
      <path d="M15 9.5C18.31 9.5 21 10.62 21 12V17C21 18.38 18.31 19.5 15 19.5" />
    </svg>
  ),
  market: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41L12 22 2 12V2H12L20.59 10.59A2 2 0 0 1 20.59 13.41Z" />
      <circle cx="7" cy="7" r="1.3" fill="currentColor" stroke="none" />
    </svg>
  ),
  admin: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3L4 6V11C4 16 7.5 20.2 12 21.5C16.5 20.2 20 16 20 11V6L12 3Z" />
      <path d="M9 12L11 14L15.5 9.5" />
    </svg>
  ),
  about: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11V17" />
      <circle cx="12" cy="7.7" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  ),
  sun: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 2.5V5" />
      <path d="M12 19V21.5" />
      <path d="M4.6 4.6L6.3 6.3" />
      <path d="M17.7 17.7L19.4 19.4" />
      <path d="M2.5 12H5" />
      <path d="M19 12H21.5" />
      <path d="M4.6 19.4L6.3 17.7" />
      <path d="M17.7 6.3L19.4 4.6" />
    </svg>
  ),
  moon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z" />
    </svg>
  ),
};

function Sidebar({ open, onClose, nickname, canManageBank, canManageWarehouse, canViewAdminPanel, bankPendingCount, marketPendingCount, activeTab, setActiveTab, theme, onToggleTheme }) {
  const darkMode = theme === 'dark';

  const go = (tab) => {
    setActiveTab(tab);
    onClose();
  };

  const hasAdminSection = canManageBank || canManageWarehouse || canViewAdminPanel;

  return (
    <>
      <div className={`sidebar-overlay ${open ? 'open' : ''}`} onClick={onClose}></div>

      <div className={`sidebar ${open ? 'open' : ''}`}>
        <div className="sidebar-header">
          <span className="sidebar-nickname" style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
            <PlayerAvatar nickname={nickname} size={28} />
            {nickname}
          </span>
          <button className="sidebar-close" onClick={onClose} aria-label="Закрыть меню">✕</button>
        </div>

        <div className="sidebar-menu">
          <button
            className={`sidebar-item ${activeTab === 'playerslist' ? 'active' : ''}`}
            onClick={() => go('playerslist')}
          >
            <span className="sidebar-item-icon">{icons.players}</span>
            Список игроков
          </button>

          {hasAdminSection && (
            <div className="sidebar-section">
              {canManageBank && (
                <button
                  className={`sidebar-item ${activeTab === 'bank-admin' ? 'active' : ''}`}
                  onClick={() => go('bank-admin')}
                >
                  <span className="sidebar-item-icon">{icons.bank}</span>
                  Банк
                  {bankPendingCount > 0 && <span className="sidebar-item-badge">{bankPendingCount > 99 ? '99+' : bankPendingCount}</span>}
                </button>
              )}
              {canManageWarehouse && (
                <button
                  className={`sidebar-item ${activeTab === 'market-admin' ? 'active' : ''}`}
                  onClick={() => go('market-admin')}
                >
                  <span className="sidebar-item-icon">{icons.market}</span>
                  Маркетплейс
                  {marketPendingCount > 0 && <span className="sidebar-item-badge">{marketPendingCount > 99 ? '99+' : marketPendingCount}</span>}
                </button>
              )}
              {canViewAdminPanel && (
                <button
                  className={`sidebar-item ${activeTab === 'admin' ? 'active' : ''}`}
                  onClick={() => go('admin')}
                >
                  <span className="sidebar-item-icon">{icons.admin}</span>
                  Админ-панель
                </button>
              )}
            </div>
          )}
        </div>

        <div className="sidebar-footer">
          <button
            className={`sidebar-item ${activeTab === 'about' ? 'active' : ''}`}
            onClick={() => go('about')}
          >
            <span className="sidebar-item-icon">{icons.about}</span>
            О приложении
          </button>
          <div className="sidebar-footer-divider"></div>
          <button
            className="theme-toggle"
            onClick={onToggleTheme}
            aria-label="Переключить тему"
          >
            <span className="theme-toggle-icon">{darkMode ? icons.moon : icons.sun}</span>
            <span className="theme-toggle-label">Тёмная тема</span>
            <span className={`theme-toggle-switch ${darkMode ? 'on' : ''}`}>
              <span className="theme-toggle-thumb"></span>
            </span>
          </button>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
